import type {
  SupplierAnnouncementUpdateRequestType,
  SupplierAnnouncementUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierAnnouncementUpdate = (
  supplierId: number,
  supplierAnnouncementId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SupplierAnnouncementUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `suppliers/${supplierId}/supplier-announcement/${supplierAnnouncementId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierAnnouncementUpdateResponseType,
      ),
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierAnnouncement,
          response.id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierAnnouncement,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SuppliersLegacy],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SuppliersLegacy,
          supplierId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Suppliers,
          supplierId,
        ],
      });
    },
  });
};
